import { render } from "./EditRoleUser.vue?vue&type=template&id=14370aea"
import script from "./EditRoleUser.vue?vue&type=script&lang=js"
export * from "./EditRoleUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__